import { render, staticRenderFns } from "./StockOrderDetails.vue?vue&type=template&id=6e485e7a&scoped=true"
import script from "./StockOrderDetails.vue?vue&type=script&lang=js"
export * from "./StockOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./StockOrderDetails.vue?vue&type=style&index=0&id=6e485e7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e485e7a",
  null
  
)

export default component.exports